import companiesKeys from '../util/companies-keys';
import {
  AccessControlProps,
  translatedAccessControlProps,
} from 'modules/access-controls/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CreateCompanyAccessControlProps
  extends Omit<AccessControlProps, 'id'> {
  createUser?: boolean;
}

export const translatedCreateCompanyAccessControlProps: TranslatedKeys<CreateCompanyAccessControlProps> =
  {
    ...translatedAccessControlProps,
    createUser: 'Criar usuário?',
  };

const useCreateCompanyAccessControl = (companyId: string) => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: AccessControlProps) =>
    create(companiesKeys.accessControls(companyId), data);

  return useApiMutation({
    url: `/access-controls/companies/${companyId}`,
    method: 'POST',
    errorTitle: 'Erro ao cadastrar controle de acesso',
    successTitle: 'Cadastrar controle de acesso',
    successMessage: 'Controle de acesso cadastrado com sucesso',
    redirectUrl: `/settings/companies/${companyId}/access-controls`,
    onSuccess,
  });
};

export default useCreateCompanyAccessControl;
